import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ComponentRef,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
    ViewContainerRef,
    ChangeDetectionStrategy
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { EditorComponentBase } from '../../classes/editor-component-base';
import { TooltipDirective } from '../../directives';
import { IComponentFactory } from '../../interfaces/component-factory.interface';
import { IEditorItemConfig } from '../../interfaces/editor-item-config.interface';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { IconSanitizerService } from '../../services';

@Component({
    selector: 'lib-editor-item',
    templateUrl: './editor-item.component.html',
    styleUrls: ['./editor-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe, TooltipDirective]
})
export class EditorItemComponent implements AfterViewInit {
    @Input()
    configItem?: IEditorItemConfig;

    @Input()
    factory?: IComponentFactory;

    @Input()
    editorItemId?: string;

    @ViewChild('editor', { read: ViewContainerRef })
    editor?: ViewContainerRef;

    @Output()
    valueChange: EventEmitter<boolean>;

    editorInstance?: ComponentRef<EditorComponentBase<unknown>>;
    infoIcon?: SafeHtml;
    private readonly iconSanitizer = inject(IconSanitizerService);

    constructor() {
        this.valueChange = new EventEmitter<boolean>();
        this.infoIcon = this.iconSanitizer.getIcon('info');
    }

    get customFieldDescription(): string | undefined {
        return (this.configItem?.bindContext as any)?.customFieldDescription;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.renderComponent();
        }, 0);
    }

    validate(): boolean {
        if (!this.editorInstance) return false;
        return this.editorInstance?.instance.validate();
    }

    clearValidationErrors(): void {
        this.editorInstance?.instance.clearValidationErrors();
    }

    private renderComponent(): void {
        if (!this.factory || !this.configItem) return;
        this.editor?.clear();

        const component = this.factory?.getComponent(this.configItem.componentId);

        this.editorInstance = this.editor?.createComponent(component);
        this.editorInstance?.instance.initialize({
            componentId: this.configItem.componentId,
            bindContext: this.configItem.bindContext,
            fieldName: this.configItem.fieldName,
            additionalInfo: this.configItem.additionalInfo,
            validations: this.configItem.validations,
            label: this.configItem.label,
            entityId: this.configItem.entityId,
            isReadOnly: this.configItem.isReadOnly
        });
        this.editorInstance?.instance.valueChange.subscribe(() => this.valueChange.emit());
    }
}
